import { Link } from "react-router-dom";
import { LOGO } from "@/data/forge";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 py-14 text-center">
      <img src={LOGO} alt="The Forge" className="h-10 w-10 rounded-lg object-cover mx-auto mb-4" />
      <p className="display text-[11px] tracking-[0.35em] text-white/35 mb-2">Roll Move Forge</p>
      <p className="text-xs text-white/25 mb-6">© 2026 The Forge. All rights reserved.</p>
      <div className="flex items-center justify-center gap-7 text-xs">
        <Link to="/privacy" data-testid="footer-privacy" className="text-ember hover:text-forge transition-colors">
          Privacy Policy
        </Link>
        <Link to="/community" data-testid="footer-community" className="text-ember hover:text-forge transition-colors">
          Community
        </Link>
        <Link to="/" data-testid="footer-home" className="text-ember hover:text-forge transition-colors">
          Home
        </Link>
      </div>
    </footer>
  );
}
